import { MuiTheme, createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    updateUserDrawerContainer: {
      width: '616px',
      background: 'white',
      color: '#2A2A2A',
      padding: '32px 0px 32px 0px',
      [theme.breakpoints.down('sm')]: {
        width: 'auto'
      },
      [theme.breakpoints.only('xs')]: {
        width: '300px'
      }
    },
    drawerAdminNameBlock: {
      alignItems: 'center',
      justifyContent: 'space-between',
      background: 'transparent',
      padding: '0px 32px 0px 32px',
      margin: '0px 0px 32px 0px',
      [theme.breakpoints.only('xs')]: {
        padding: '0px 10px 0px 10px'
      }
    },
    updateUserAdminName: {
      fontSize: '32px !important',
      margin: '0px !important',
      width: '450px !important',
      wordBreak: 'break-word',
      [theme.breakpoints.only('xs')]: {
        fontSize: '29px !important',
        width: '200px !important',
        whiteSpace: 'normal !important',
        wordBreak: 'break-all'
      }
    },
    updateDrawerCloseIcon: {
      '& > * > *': {
        [theme.breakpoints.only('xs')]: {
          width: '30px',
          height: '30px'
        }
      }
    },
    userFormContainer: {
      background: 'transparent',
      padding: '40px 40px 20px 32px',
      display: 'flex',
      [theme.breakpoints.only('xs')]: {
        padding: '30px 20px 0px 20px'
      }
    },
    userFormCheckboxBlock: {
      background: 'transparent',
      justifyContent: 'space-around',
      display: 'flex',
      flexDirection: 'row',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        marginBottom: '12px'
      }
    },
    updateTextInputBlock: {
      background: 'transparent',
      height: '130px',
      minWidth: '100%',
      [theme.breakpoints.down('xs')]: {
        height: '100px'
      },
      '& > * > * > input': {
        [theme.breakpoints.down('xs')]: {
          height: '40px'
        }
      }
    },
    updateVenueLabel: {
      padding: '16px 24px',
      margin: '0px 0px 10px',
      fontSize: '16px',
      fontWeight: 'bold'
    },
    updatePinCodeBlock: {
      background: 'transparent',
      height: '130px',
      minWidth: '50%',
      [theme.breakpoints.down('xs')]: {
        height: '100px'
      },
      '& > * > * > input': {
        [theme.breakpoints.down('xs')]: {
          height: '40px'
        }
      }
    },
    updateUserPinCodeBlock: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      background: 'transparent',
      minWidth: '100%',
      justifyContent: 'space-between',
      [theme.breakpoints.only('xs')]: {
        flexDirection: 'column'
      }
    },
    updateFormPinCodeButtonBox: {
      height: '100px',
      [theme.breakpoints.down('xs')]: {
        height: '100px',
        display: 'inline-flex',
        flexDirection: 'column'
      },
      '& > * > * > input': {
        [theme.breakpoints.down('xs')]: {
          height: '80px'
        }
      },
      margin: '32px 0px 0px 0px',
      [theme.breakpoints.down('xs')]: {
        margin: '22px 0px 0px 0px'
      }
    },
    updateAdminPasswordBox: {
      background: 'transparent',
      height: '130px',
      minWidth: '100%',
      [theme.breakpoints.down('xs')]: {
        height: '100px'
      },
      '& > * > * > input': {
        [theme.breakpoints.down('xs')]: {
          minWidth: '200px',
          height: '40px'
        }
      }
    },
    updateVenueBox: {
      background: 'transparent',
      height: '100px',
      minWidth: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      [theme.breakpoints.down('xs')]: {
        height: '100px'
      },
      '& > * > *': {
        [theme.breakpoints.down('xs')]: {
          minWidth: '240px',
          width: '245px'
        }
      }
    },
    updateSendAlertBlock: {
      display: 'flex',
      flexDirection: 'row',
      background: 'transparent',
      height: '68px',
      alignItems: 'center',
      padding: '16px 24px 16px 24px',
      [theme.breakpoints.down('xs')]: {
        padding: '16px 0px 16px 0px'
      }
    },
    updateUserSave: {
      padding: '0px 32px',
      margin: '4px 0px 0px',
      '& > *': {
        [theme.breakpoints.down('xs')]: {
          width: '100%',
          padding: '0px 20px'
        }
      }
    },
    updateUserSaveButton: {
      [theme.breakpoints.down('xs')]: {
        height: '40px'
      }
    }
  })
);
